import DOMPurify from "dompurify";

// The only place in this app that sanitizes before dangerouslySetInnerHTML
// (existing CKEditor-authored fields elsewhere are trusted internal
// content rendered unsanitized). Chat citation summaries come from
// Elasticsearch source documents via the chatbot backend, so sanitize
// before rendering as HTML.
const sanitizeHtml = html => DOMPurify.sanitize(html || "");

export default sanitizeHtml;
